import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../../DependencyHelper";
import formStyles from "../../NewLineForms.module.scss";
import { africaCountryCode } from "../../../../../utils/helperServices";
import labels from "../../../../../config/labels";

const ContactDetailsForm = ({
  formName,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  onChangeHandler,
  onBlurHandler,
}) => {
  const handleChange = event => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = event => {
    onBlurHandler(event, null, formName);
  }

  return (
    <CustomContainer className={`${formStyles["main-container"]}`}>
      <Form.Row className={`${formStyles["main-row"]}`}>
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormcd101`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormcd101-label`}
          >
            Cellphone number
          </Form.Label>
          <Form.Control
            type="text"
            maxLength={
              africaCountryCode(fieldValues["cellNumber"]) ? "11" : "10"
            }
            name="cellNumber"
            value={fieldValues["cellNumber"]}
            placeholder="Add your cellphone number"
            onChange={handleChange}
            isInvalid={fieldErrors["cellNumber"]}
            className={fieldErrors["cellNumber"] ? formStyles["invalid"] : ""}
            onBlur={handleBlur}
          />
          <Form.Control.Feedback
            type="invalid"
            className={formStyles["invalid-feedback"]}
          >
            {fieldErrorsMessage["cellNumber"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormcd102`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormcd102-label`}
          >
            Email address
          </Form.Label>
          <Form.Control
            disabled
            type="text"
            name="emailAddress"
            value={fieldValues["emailAddress"]}
            placeholder="Add your email address"
            onChange={handleChange}
            isInvalid={fieldErrors["emailAddress"]}
            className={formStyles["disable-input"]}
            onBlur={handleBlur}
          />
          <div className={formStyles["hint-text"]}>
            {labels.auth.lbl_email_readOnly}
          </div>
        </Form.Group>
      </Form.Row>
    </CustomContainer>
  );
};

ContactDetailsForm.propTypes = {
  formName: PropTypes.string,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  onChangeHandler: PropTypes.func,
};

ContactDetailsForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
};

export default ContactDetailsForm;
